import { GenericTable } from "@shared/components/GenericTable";
import { PageHeader } from "@shared/components/PageHeader";
import { TableColumn } from "@shared/types/table";
import { Card } from "@shared/ui/card";
import { BarChart3, Wrench } from "lucide-react";
import { useState } from "react";

interface ReadingRecord {
  date: string;
  month: string;
  readType: string;
  reading: number;
  status: 'valid' | 'invalid';
  reader: string;
  validator: string;
    startDate?: string;
  endDate?: string;
}

export const HistoricalPerformance = ({ data }: { data?: any[] }) => {
  const readingsData = data ?? [];
  const [currentPage, setCurrentPage] = useState(1);

  const columns: TableColumn<ReadingRecord>[] = [
    {
      key: "label",
      header: "Time Period",
      headerTooltip:"Cycle or time window used for comparison."
    },
 {
  key: "readingPeriod",
  header: "Reading Period",
  render: (value, row) => {  
    if (row?.startDate && row?.endDate) {
      return `${row.startDate} - ${row.endDate}`;
    }
    return "N/A";
  },
  headerTooltip: (
    <div className="text-sm max-w-xs leading-snug">
      <p>
        The date range from the latest run date to its due date for the cycle.
        Use this to contextualize KPIs to their operational window.
      </p>
      <p className="mt-2">
        <strong>Optimization:</strong> Align staffing and dispatch plans within
        this window to improve on-time completion.
      </p>
    </div>
  )
},
    {
      key: "completionRate",
      header: "Completion Rate",
      headerTooltip:"Share of scheduled meters completed in the period."
    },
    {
      key: "onTimeCompletion",
      header: "On-Time Completion",
      headerTooltip:"Finished before or on due dates within the period."
    },
    {
      key: "readingAccuracy",
      header: "Reading Accuracy",
      headerTooltip:"Percent of readings accepted without corrections."
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
<div>
             <PageHeader
            title="Historical Performance"
            subtitle="Compare key KPIs across cycles."
          />
  <div className="pt-2">
    <GenericTable
      data={readingsData}
      columns={columns}
      rowKey="date"
      pagination={{
        currentPage,
        totalPages: Math.ceil(readingsData.length / 10), // Assuming 10 items per page
        totalItems: readingsData.length,
        itemsPerPage: 10,
        startItem: (currentPage - 1) * 10 + 1,
        endItem: Math.min(currentPage * 10, readingsData.length)
      }}
      onPageChange={handlePageChange}
      searchPlaceholder="Search readings..."
      emptyMessage="No readings found"
    />

</div>
   </div>)
};